// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__P78CP","close":"styles_close__w5N+i","ttl":"styles_ttl__uRQmG","txt":"styles_txt__FAmx3","btn":"styles_btn__ldXdG"};